import { useEffect } from 'react'
import { useParams, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import RootLayout from './RootLayout'
import { isLang, DEFAULT_LANG } from '../config/locales'
import { loadLocale } from '../i18n'

export default function LangLayout() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()
  const valid = !!lang && isLang(lang)

  useEffect(() => {
    if (valid && lang && isLang(lang)) {
      if (i18n.language !== lang) {
        // Locales are per-locale lazy chunks (see src/i18n.ts); make sure the
        // target bundle is registered before switching so the re-render that
        // changeLanguage triggers resolves every key. Until it lands, the page
        // shows the fallback locale for a beat - same data, no broken keys.
        // On a failed chunk fetch (offline/CDN hiccup) still switch: fallback
        // strings beat a dead language switcher.
        void loadLocale(lang)
          .catch(() => {})
          .then(() => i18n.changeLanguage(lang))
      }
      document.documentElement.lang = lang
    }
  }, [valid, lang, i18n])

  if (!valid) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />
  }

  return <RootLayout />
}
